import { createFileRoute, redirect } from '@tanstack/react-router'

import { MENU } from '@/constants/common/message.constants'
import { getDefaultUserMeTenant } from '@/features/auth/models'
import { USER_TYPE } from '@/libs/api/types'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/contracts/tariff/create'
)({
  meta: () => [{ title: `${MENU.NEW_REGISTRATION}（${MENU.TARIFF}）` }],
  beforeLoad: ({ context: { auth } }) => {
    if (auth?.user?.type !== USER_TYPE.OWNER) {
      // DCユーザー以外の場合は契約一覧にリダイレクト
      throw redirect({
        to: `/${getDefaultUserMeTenant(auth.user).key}/settings/contracts`
      })
    }
  }
})
